<template>

  <div>

    <v-snackbar
        v-model="snackbar.error"
        color="error"
        :multi-line="true"
        :timeout="snackbar.timeout" >
      {{ snackbar.errorMessage }}
    </v-snackbar>
    <v-snackbar
        v-model="snackbar.success"
        color="success"
        :multi-line="true"
        :timeout="snackbar.timeout" >
      {{ snackbar.successMessage }}
    </v-snackbar>

    <v-dialog v-model="show" persistent max-width="600px">
      <LoadingDialog v-model="showLoadingDialog"></LoadingDialog>

      <v-card>
        <v-card-title>
          <h2>Update Address</h2>
          <v-spacer></v-spacer>
          <v-btn flat icon color="itoviGrayMid" @click="resetAndClose"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="pt-0">






          <v-form ref="addressForm" v-model="addressFormValid" lazy-validation>
            <v-container fluid grid-list-md>
              <v-layout align-start justify-space-between wrap>
                <v-flex d-flex xs12>
                  <v-text-field :rules="genericRequiredFieldRule" v-model="componentForm.street_and_house" id="autocomplete" placeholder="Address" required></v-text-field>
                </v-flex>
                <v-flex d-flex xs12>
                  <v-text-field v-model="componentForm.address_line_2" label="Address line 2 (optional)"></v-text-field>
                </v-flex>
                <v-flex d-flex xs6>
                  <v-text-field :rules="genericRequiredFieldRule" v-model="componentForm.locality" label="City"></v-text-field>
                </v-flex>
                <v-flex d-flex xs6>
                  <v-text-field :rules="genericRequiredFieldRule" v-model="componentForm.administrative_area_level_1" label="State"></v-text-field>
                </v-flex>
                <v-flex d-flex xs6>
                  <v-text-field :rules="genericRequiredFieldRule" v-model="componentForm.postal_code" label="Postal Code"></v-text-field>
                </v-flex>
                <v-flex d-flex xs6>
                  <v-text-field :rules="genericRequiredFieldRule" v-model="componentForm.country" label="Country Code"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>




        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="resetAndClose">Cancel</v-btn>
          <v-btn color="primary" flat @click="submitBillingAddressChange">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>
  import api from "../../../services/api_endpoints"
  import LoadingDialog from "../../LoadingDialog"

  export default {
    components: {
      LoadingDialog
    },
    data: ()=> ({
      genericRequiredFieldRule: [
        v => !!v || 'This field is Required'
      ],
      addressFormValid: false,
      placeSearch: null,
      autocomplete: null,
      componentForm: {
        street_number: '',
        route: '',
        locality: '',
        administrative_area_level_1: '',
        country: '',
        postal_code: '',
        street_and_house: null,
        address_line_2: null,
      },
      showLoadingDialog: false,
      snackbar: {
        success: false,
        error: false,
        timeout: 1500,
        errorMessage: "An unknown error occurred",
        successMessage: "Address updated successfully"
      },
    }),
    props: {
      value: {
        type: Boolean,
        default: false
      },
      currentAddress:{
        type: Object,
        required: false,
        default: () => ({
          primary: '',
          secondary: '',
          city: '',
          state: '',
          postal_code: '',
          country: ''
        })
      }
    },
    async mounted() {
      this.initAutocomplete()
      this.componentForm.street_and_house = this.currentAddress.primary
      this.componentForm.locality = this.currentAddress.city
      this.componentForm.administrative_area_level_1 = this.currentAddress.state
      this.componentForm.postal_code = this.currentAddress.postal_code
      this.componentForm.country = this.currentAddress.country
      this.componentForm.address_line_2 = this.currentAddress.secondary

      this.$refs.addressForm.resetValidation()
    },
    methods: {
      resetAndClose() {
        this.$refs.addressForm.resetValidation()
        this.show = false
      },
      initAutocomplete() {
        // Create the autocomplete object, restricting the search predictions to
        // geographical location types.
        // eslint-disable-next-line no-undef
        this.autocomplete = new google.maps.places.Autocomplete(
          document.getElementById('autocomplete'), {types: ['geocode']});

        // Avoid paying for data that you don't need by restricting the set of
        // place fields that are returned to just the address components.
        this.autocomplete.setFields(['address_component']);

        // When the user selects an address from the drop-down, populate the
        // address fields in the form.
        this.autocomplete.addListener('place_changed', this.fillInAddress);
      },
      getAddressComponentName(addressType) {
        return (addressType === 'administrative_area_level_1' ||
          addressType === 'postal_code' ||
          addressType === 'street_number' ||
          addressType === 'country')
          ? 'short_name'
          : 'long_name'
      },
      fillInAddress() {
        // Get the place details from the autocomplete object.
        let place = this.autocomplete.getPlace();

        // Get each component of the address from the place details,
        // and then fill-in the corresponding field on the form.
        for (let i = 0; i < place.address_components.length; i++) {
          // console.log(place.address_components[i])
          let addressType = place.address_components[i].types[0];
          if (this.componentForm.hasOwnProperty(addressType)) {
            this.componentForm[addressType] = place.address_components[i][this.getAddressComponentName(addressType)]
          }
        }
        this.componentForm.street_and_house = `${this.componentForm.street_number} ${this.componentForm.route}`
      },
      async submitBillingAddressChange() {
        if (!this.$refs.addressForm.validate()) return

        this.showLoadingDialog = true
        let response = await api.submitBillingAddressChange({
          address: `${this.componentForm.street_and_house}`,
          address_2: this.componentForm.address_line_2 != null ? this.componentForm.address_line_2 : '',
          city: `${this.componentForm.locality}`,
          state: `${this.componentForm.administrative_area_level_1}`,
          postal_code: `${this.componentForm.postal_code}`,
          country: `${this.componentForm.country}`,
        })
        this.showLoadingDialog = false

        if (response.success) {
          this.snackbar.success = true
          // pull the new address
          await api.getUser()
          this.show = false
        } else {
          if (response.errorMessage !== '') this.snackbar.errorMessage = response.errorMessage
          this.snackbar.error = true
        }
      }
    },
    computed: {
      show: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        }
      }
    }
  }
</script>
